import { getCaregiver, getCaregiverVariables } from '@/__generated__/getCaregiver';
import { MultipleVerticalsTypes } from '@/__generated__/globalTypes';
import { useLazyQuery } from '@apollo/client';
import router from 'next/router';
import { Member } from '@/__generated__/Member';
import { GET_SITTER_INFO, GET_MEMBER_QUERY } from '../request/GQL';
import { useAppDispatch } from '../AppState';
import useMultiVerticalServiceTypes from './useMultiVerticalServiceTypes';

const useGetProviderLocation = () => {
  const dispatch = useAppDispatch();
  const mapVerticalToServiceType = useMultiVerticalServiceTypes();

  const [loadGetCareGiverLocation] = useLazyQuery<getCaregiver, getCaregiverVariables>(
    GET_SITTER_INFO,
    {
      onCompleted: (data) => {
        dispatch({
          type: 'setProviderMVZipCode',
          value: data.getCaregiver.member.address?.zip as string,
        });
      },
    }
  );
  const [getMember] = useLazyQuery<Member>(GET_MEMBER_QUERY, {
    onCompleted: (data) => {
      loadGetCareGiverLocation({
        variables: {
          id: data.member.id,
          serviceId: mapVerticalToServiceType(router.query.vertical as MultipleVerticalsTypes),
        },
      });
    },
  });
  const setProviderLocation = () => {
    getMember();
  };
  return { setProviderLocation };
};

export default useGetProviderLocation;
